import React, { useContext } from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { AppContext } from '@prisjakt/ui-app-context';
import { IconHomeDelivery } from '@prisjakt/ui/icon';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import * as S from './styles';

export const HomeDelivery: React.FC = () => {
  const { offer } = usePriceRowContext();
  const { deliveryOptions } = offer;
  const { t } = useContext(AppContext);

  const homeDelivery =
    deliveryOptions &&
    deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  return homeDelivery ? (
    <S.HomeDelivery>
      <IconHomeDelivery color="base400" />
      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        {t('product', 'home-delivery.info-3')}
      </CaptionText>
    </S.HomeDelivery>
  ) : null;
};
